exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.member_label_tabs[data-v-183217c3]{\n  padding: 12px;\n}\n", ""]);

// exports
